import axios from "axios";
import app from "../_app";

const cart = document.querySelector('.js-cart');

if (cart) {
    [...cart.querySelectorAll('.js-cart-item')].map(item => {

        /**
         * Remove action
         */
        const removeTrigger = item.querySelector('.js-cart-item-remove');
        removeTrigger.addEventListener('click', () => {
            updateCart(item.dataset.id, 0);
        });
    });


    /**
     * Summary
     * @type {Element}
     */
    const extendSummary = cart.querySelector('.js-extend-summary');

    if (extendSummary) {
        extendSummary.addEventListener('click', () => {
            cart.querySelector('.js-cart-summary-small').classList.add('d-none');
            cart.querySelector('.js-cart-summary-full').classList.remove('d-none');
            //cart.querySelector('.js-cart-summary-total').remove();
            //extendSummary.remove();
        });
    }

    const updateCart = async (id, quantity) => {
        let response = await axios.post(`${window.Shopify.routes.root}cart/update.js`, {updates: {[id]: quantity}});
        document.body.style.opacity = .3;

        if (response.status === 200) {
            location.reload();
        }
    }

    if (app.viewport.isEqualOrGreaterThan('lg')) {
        document.querySelectorAll('.js-cart-fixed-buttons').forEach($fixed => {

            let scrollTop = 0;
            const $summaryButton = document.querySelector('.js-summary-button');

            if ($summaryButton) {
                window.addEventListener('scroll', () => {
                    scrollTop = $summaryButton.getBoundingClientRect().top + $summaryButton.offsetHeight;

                    if (scrollTop < 0) {
                        $fixed.classList.add('active');
                    } else {
                        $fixed.classList.remove('active');
                    }
                });
            }
        });
    }
}
